import i18n from 'i18next'
import LanguageDetector from "i18next-browser-languagedetector"
import {initReactI18next} from 'react-i18next'
import HttpApi from 'i18next-http-backend';
import languageEN from './locales/en/translate.json'
import languageTA from './locales/ta/translate.json'
import languageTE from './locales/te/translate.json'
import languageML from './locales/ml/translate.json'
import languageHI from './locales/hi/translate.json'
import languageBN from './locales/bn/translate.json'
import { getLanguage } from './utils/common'

i18n
.use(HttpApi)
.use(LanguageDetector)
.use(initReactI18next)
.init({
    resources: {
        en: languageEN,
        ta: languageTA,
        te: languageTE,
        ml: languageML,
        hi: languageHI,
        bn: languageBN,
    },
    lng: getLanguage(),
    
    fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
        escapeValue: false,
        formatSeparator: ","
    },
    react: {
        wait: true,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default'
    }
})

export default i18n;